import { orchestrator } from 'satcheljs';
import { changeTheme } from 'owa-fabric-theme';
import { setThemeOnProvider } from '../utils/fluidProps/getAppStylingProvider';

orchestrator(changeTheme, actionMessage => {
    setThemeOnProvider();
});
